module.exports = __webpack_public_path__ + "53676798424fabf517b717e52344fb48.pdf";